import React from 'react'
import { collection, query, where, doc, getDoc, getDocs, setDoc, updateDoc, serverTimestamp } from "firebase/firestore";
import { db } from '../firebase';
import { useAuth } from '../contexts/AuthContext'

const Search = () => {
   const [username, setUsername] = React.useState('')
   const [user, setUser] = React.useState(null)
   const [error, setError] = React.useState('')

   const { user: cUser } = useAuth()

   const handleSearch = async () => {
      const usersRef = collection(db, 'users');
      const q = query(usersRef, where('displayName', '==', username));

      try {
         const querySnapshot = await getDocs(q);
         querySnapshot.forEach((doc) => {
            setUser(doc.data())
         })
      } catch (error) {
         setError(error.message)
      }
   }

   const handleKeydown = (e) => {
      e.code === 'Enter' && handleSearch()
   }

   const handleSelect = async () => {
      const cId = cUser.uid > user.uid ? cUser.uid + user.uid : user.uid + cUser.uid

      try {
         const response = await getDoc(doc(db, 'chats', cId))

         if (!response.exists()) {
            await setDoc(doc(db, 'chats', cId), { messages: [] })

            await updateDoc(doc(db, 'userChats', cUser.uid), {
               [cId + '.userInfo']: {
                  uid: user.uid,
                  displayName: user.displayName,
                  photoURL: user.photoURL
               },
               [cId + '.date']: serverTimestamp()
            })

            await updateDoc(doc(db, 'userChats', user.uid), {
               [cId + '.userInfo']: {
                  uid: cUser.uid,
                  displayName: cUser.displayName,
                  photoURL: cUser.photoURL
               },
               [cId + '.date']: serverTimestamp()
            })
         }
      } catch (error) {

      }
      setUser(null)
      setUsername('')
   }

   return (
      <div className='px-8 py-4'>
         <div className='mb-4'>
            <input className='border-none rounded-xl w-full px-6 py-4 bg-dark-20 placeholder:text-gray-300 focus:outline-none' type='text' placeholder='Find a user' onKeyDown={handleKeydown} value={username} onChange={(e) => setUsername(e.target.value)} />
         </div>
         {error && <span>{error}</span>}
         {user && (
            <div className='flex gap-4 items-center bg-dark-20 px-6 py-4 rounded-2xl hover:cursor-pointer' onClick={handleSelect}>
               <img className='h-16 w-16' src={user.photoURL} alt='user' />
               <span>{user.displayName}</span>
            </div>
         )}
      </div>
   )
}

export default Search